// TripFormModal.jsx — NEW. Add or edit ONE trip on an existing client.
// Reuses the trip-level wizard steps (Trip → Payment → Services → Refund).
//   add  → POST  /crm/clients/:id/trips
//   edit → PATCH /crm/clients/:id/trips/:tripIndex
// (The parent supplies onSubmit which performs the call + reload.)
import React, { useState } from "react";
import { Btn } from "../ui";
import { Ico } from "./primitives";
import { StepIndicator, Step2, Step3, Step4, Step5 } from "./formSteps";
import { TRIP_STEPS, normaliseDestinations, tripToFormData } from "./constants";
import { BRAND } from "../brand";

const STEP_COMPONENTS = [Step2, Step3, Step4, Step5];

// client: the client this trip belongs to — prefills the Refund step.
export default function TripFormModal({ initial = null, onSubmit, onClose, saving, client = null }) {
  const isEdit = !!initial;
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    fullName: client?.fullName || "",
    email: client?.email || "",
    phone: client?.phone || "",
    countryOfResidence: client?.countryOfResidence || "",
    refundDraft: null,
    tripData: isEdit
      ? tripToFormData(initial)
      : { payment: { currency: BRAND.currency }, refund: { refundRequested: false } },
  });

  const StepComp = STEP_COMPONENTS[step - 1];

  const handleSubmit = () => {
    onSubmit(normaliseDestinations(data.tripData), data.refundDraft || null);
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: "rgba(10,15,30,0.72)", backdropFilter: "blur(12px)" }}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[92vh] flex flex-col"
        style={{ animation: "modalIn .22s cubic-bezier(.34,1.56,.64,1)" }}
      >
        <div className="px-7 pt-6 pb-5 border-b border-slate-100 flex-shrink-0">
          <div className="flex items-center justify-between mb-5">
            <div>
              <h2 className="text-lg font-black text-slate-800">{isEdit ? "Edit Trip" : "Add Trip"}</h2>
              <p className="text-xs text-slate-400 mt-0.5">
                {TRIP_STEPS[step - 1].label} · Step {step} of {TRIP_STEPS.length}
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-xl bg-slate-100 hover:bg-rose-50 hover:text-rose-400 flex items-center justify-center text-slate-400 transition-all"
            >
              <Ico d="M6 18L18 6M6 6l12 12" sz={13} />
            </button>
          </div>
          <StepIndicator steps={TRIP_STEPS} current={step} onStepClick={setStep} />
        </div>

        <div className="flex-1 overflow-y-auto px-7 py-5">
          <StepComp data={data} onChange={setData} />
        </div>

        <div className="px-7 py-4 border-t border-slate-100 flex items-center justify-between flex-shrink-0">
          <Btn variant="secondary" size="sm" disabled={step === 1} onClick={() => setStep((s) => s - 1)}>
            ← Back
          </Btn>
          <div className="flex items-center gap-2">
            {/* Save is always available — you can jump between steps freely and save anytime. */}
            <Btn variant="secondary" size="sm" loading={saving} onClick={handleSubmit}>
              {isEdit ? "Save Trip" : "Add Trip"}
            </Btn>
            {step < TRIP_STEPS.length && (
              <Btn variant="primary" onClick={() => setStep((s) => s + 1)}>
                Continue →
              </Btn>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}